import type { GeoToolName } from "../../shared/geo.js";
import {
  DEFAULT_DISTANCE_METERS,
  DEFAULT_INTERSECT_A,
  DEFAULT_INTERSECT_B,
  DEFAULT_LINE,
  DEFAULT_POINT,
  DEFAULT_POLYGON,
} from "../../shared/geo.js";

export type CatalogApp = {
  id: GeoToolName | "composer";
  slug: string;
  name: string;
  desc: string;
  tool?: GeoToolName;
  resourceUri?: string;
  viewFile?: string;
  enabled: boolean;
  featured?: boolean;
  defaults: Record<string, unknown>;
};

export const CATALOG: CatalogApp[] = [
  {
    id: "geo.buffer",
    slug: "buffer",
    name: "Buffer",
    desc: "Halo alrededor de un punto o línea. La vista pide; el host calcula con WebR + sf.",
    tool: "geo.buffer",
    resourceUri: "ui://ansgis/geo.buffer",
    viewFile: "buffer.html",
    enabled: true,
    featured: true,
    defaults: {
      geometry: DEFAULT_POINT,
      distanceMeters: DEFAULT_DISTANCE_METERS,
    },
  },
  {
    id: "geo.centroid",
    slug: "centroid",
    name: "Centroid",
    desc: "Punto medio de una geometría (sf::st_centroid).",
    tool: "geo.centroid",
    resourceUri: "ui://ansgis/geo.centroid",
    viewFile: "centroid.html",
    enabled: true,
    defaults: { geometry: DEFAULT_POLYGON },
  },
  {
    id: "geo.measure",
    slug: "measure",
    name: "Measure",
    desc: "Largo y área en metros (s2).",
    tool: "geo.measure",
    resourceUri: "ui://ansgis/geo.measure",
    viewFile: "measure.html",
    enabled: true,
    defaults: { geometry: DEFAULT_LINE },
  },
  {
    id: "geo.intersect",
    slug: "intersect",
    name: "Intersect",
    desc: "Intersección de dos polígonos (sf::st_intersection).",
    tool: "geo.intersect",
    resourceUri: "ui://ansgis/geo.intersect",
    viewFile: "intersect.html",
    enabled: true,
    defaults: {
      geometry: DEFAULT_INTERSECT_A,
      other: DEFAULT_INTERSECT_B,
    },
  },
  {
    id: "composer",
    slug: "composer",
    name: "Composer",
    desc: "Pronto — ui://ansgis/composer (schema → form). No MiniKitAns.",
    enabled: false,
    defaults: {},
  },
];
